export default {
  separator: {
    display: 'block',
    height: '1px',
    backgroundColor: '#e5e5e5',
    margin: '5px 0'
  }
}
